import type { Dayjs } from 'dayjs';

// Builds a Monday-first calendar grid for the given month. Leading/trailing
// empty slots (null) pad the first and last weeks so the grid is a whole number
// of 7-day rows.
export const buildCalendarGrid = (viewMonth: Dayjs): (Dayjs | null)[] => {
  const start = viewMonth.startOf('month');
  const daysInMonth = viewMonth.daysInMonth();
  // Monday-first offset: JS day() returns 0=Sun..6=Sat → Mon=0..Sun=6.
  const dayOfWeek = start.day();
  const offset = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

  const cells: (Dayjs | null)[] = Array.from<null>({ length: offset }).fill(
    null
  );

  for (let day = 1; day <= daysInMonth; day++) {
    cells.push(viewMonth.date(day));
  }

  while (cells.length % 7 !== 0) cells.push(null);

  return cells;
};
